<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><span><i>To the websites and e-groups that educate and inspire</i></span></p>
<p class="center1"><span><i>those of us with the incurable cancer multiple myeloma</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?6fd25984